export default "__VITE_ASSET__Uxm$05V4__"